// covered-by: frontends/carrie/src/routes/ask-puntt/components/canvas/blocks/__tests__/MetricBlock.test.tsx
import { Robot } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";
import cx from "classnames";

import {
  agentComponentIdAttr,
  type ChatAtomAgentComponentId,
  type ChatAtomAgentComponentInstanceId,
  CHAT_ATOM_AGENT_COMPONENT_IDS,
} from "../../../agentComponents/chatAtomRegistry";

/**
 * Figma MetricBlockCondensed 49612:38 — robot + accent value + label in a
 * single horizontal chip (no trend).
 */
export function MetricBlockCondensed({
  label,
  value,
  agentComponentId = CHAT_ATOM_AGENT_COMPONENT_IDS.metricBlockCondensed,
  className,
  "data-testid": dataTestId = "metric-block-condensed",
}: {
  label: string;
  value: string;
  agentComponentId?:
    | ChatAtomAgentComponentId
    | ChatAtomAgentComponentInstanceId;
  className?: string;
  "data-testid"?: string;
}) {
  return (
    <div
      {...agentComponentIdAttr(agentComponentId)}
      data-testid={dataTestId}
      data-size="compact"
      // why: Figma 49612:38 keeps white fill + neutral stroke; panel chrome stays bare.
      className={cx(
        "flex min-w-0 items-center gap-2 overflow-hidden rounded-lg border border-puntt-neutral-gray-6 bg-base-white px-3 py-2",
        className,
      )}
    >
      <Robot
        size={14}
        className="shrink-0 text-puntt-neutral-gray-11"
        aria-hidden
        data-testid={`${dataTestId}-icon`}
      />
      <Text
        as="span"
        size="3"
        weight="medium"
        className="shrink-0 text-puntt-accent-10"
        data-testid={`${dataTestId}-value`}
      >
        {value}
      </Text>
      <Text
        as="span"
        size="1"
        className="min-w-0 truncate text-puntt-neutral-gray-11"
        data-testid={`${dataTestId}-label`}
      >
        {label}
      </Text>
    </div>
  );
}
